import { Flex } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import useCloudwatchLogger from '~/hooks/useCloudwatchLogger'
import { Size } from '~/types/ThemeTypes'

import { Checkbox } from '@mangovoice/mango-ui'

const FeedbackReasonsModal = () => {
  const { t } = useTranslation()
  const [selectedOptions, setSelectedOptions] = useState<string[]>([])
  const {
    feedbackModal: [feedbackModalState, setFeedbackModalState],
  } = useModalState()
  const { logger } = useCloudwatchLogger('FeedbackReasonsModal')

  const reasons = [
    {
      name: t('webPhone.feedback.reason.soundDelayed', 'Sound was delayed'),
      value: 'call_fb_sound_delayed',
    },
    {
      name: t(
        'webPhone.feedback.reason.couldntHearOthers',
        "I couldn't hear others",
      ),
      value: 'call_fb_couldnt_hear_others',
    },
    {
      name: t('webPhone.feedback.reason.echo', 'There was echo'),
      value: 'call_fb_echo',
    },
    {
      name: t(
        'webPhone.feedback.reason.audioBreakingUp',
        'Audio was breaking up',
      ),
      value: 'call_fb_audio_breaking_up',
    },
    {
      name: t(
        'webPhone.feedback.reason.othersCouldntHearMe',
        "Others couldn't hear me",
      ),
      value: 'call_fb_others_couldnt_hear_me',
    },
    {
      name: t('webPhone.feedback.reason.otherAudioIssue', 'Other audio issue'),
      value: 'call_fb_other_audio_issue',
    },
  ]

  const handleSubmitFeedback = () => {
    for (const reason of selectedOptions) {
      logger?.info(reason)
    }
    handleCloseModal()
  }

  const handleCloseModal = () => {
    setFeedbackModalState({ open: false })
    setSelectedOptions([])
  }

  const handleDismissModal = () => {
    logger?.info('call_fb_dismiss')
    handleCloseModal()
  }

  return (
    <MangoModal
      size={Size.sm}
      isOpen={feedbackModalState.open}
      header={t('webPhone.feedback.modal.header', 'What went wrong?')}
      footer={
        <Flex justifyContent={'flex-end'} gap={'2'}>
          <MangoButton
            onClick={handleDismissModal}
            variant={MangoButtonVariant.Default_100}
          >
            {t('webPhone.feedback.modal.dismiss', 'Dismiss')}
          </MangoButton>
          <MangoButton onClick={handleSubmitFeedback}>
            {t('webPhone.feedback.modal.submit', 'Submit Feedback')}
          </MangoButton>
        </Flex>
      }
      onClose={handleDismissModal}
    >
      <Flex direction={'column'}>
        {reasons.map((reason) => (
          <Checkbox
            key={reason.value}
            defaultChecked={selectedOptions.includes(reason.value)}
            onCheckedChange={(e) => {
              const checked = e.checked === true
              if (checked) {
                setSelectedOptions([...selectedOptions, reason.value])
              } else {
                setSelectedOptions(
                  selectedOptions.filter((option) => option !== reason.value),
                )
              }
            }}
          >
            {reason.name}
          </Checkbox>
        ))}
      </Flex>
    </MangoModal>
  )
}

export default FeedbackReasonsModal
